<template>
  <div id="team-area-container" class="container">
    <div>
      <cancellation-modal
        ref="cancellationModal"
        header-class="anchor-modal"
        :title="selectedModal.title"
        :description="selectedModal.description"
        :deleteButtonLabel="selectedModal.deleteButtonLabel"
        @deleteClick="deleteClicked()"
      />
      <b-card no-body v-show="owner">
        <h3 class="p-3">Main Account</h3>
        <main-account-card
          :owner="owner"
          @enter-click="clickOnEnter(owner)"
        />
      </b-card>
      <b-card no-body class="top20">
        <h3 class="p-3">Teams</h3>
        <b-tabs v-model="tabIndex" pills variant="info" class="nav-fill" card>
          <b-tab>
            <template slot="title">
              Joined ({{ joinedCount }})
            </template>
            <filter-table
              primary-key="id"
              :fields="fieldsMyTeams"
              :items="itemsMyTeams"
              :slots="templates"
              :show-empty="false">
                <template slot="actions" slot-scope="row">
                  <b-button
                    size="sm"
                    class="btn-anchor"
                    aria-label="Action"
                    @click.stop="clickOnEnter(row.row.item)"
                  >Enter</b-button>
                  <font-awesome-icon v-if="row.row.item.role !== 'Owner'"
                  icon="trash"
                  color="#cc0000"
                  class="trash-icon ml-3"
                  @click.stop="clickOnDisconnect(row.row.item)"
                  />
                </template>
            </filter-table>
          </b-tab>
          <b-tab>
            <template slot="title">
              Invitations
              <b-badge variant="danger" v-if="activeInvitations > 0">
                {{ activeInvitations }}
              </b-badge>
            </template>
            <filter-table
              primary-key="id"
              :fields="fieldsInvite"
              :items="itemsInvite"
              :slots="templates"
              :show-empty="false">
                <template slot="actions" slot-scope="row">
                  <b-button
                    v-if="row.row.item.status === 'pending'"
                    size="sm"
                    class="btn-success"
                    aria-label="Action"
                    @click.stop="clickOnAcceptInvite(row.row.item)"
                  >Accept</b-button>
                  <b-button
                    v-if="row.row.item.status === 'pending'"
                    size="sm"
                    class="btn-danger"
                    aria-label="Action"
                    @click.stop="clickOnRejectInvite(row.row.item)"
                  >Reject</b-button>
                </template>
            </filter-table>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>

import helper from '@/libs/helper';

import FilterTable from '@/components/utils/FilterTable';
import CancellationModal from '@/components/utils/CancellationModal';

import MY_TEAMS_MODEL from '@/components/auth/teams_area/resources/myTeamsModel.json';
import INVITES_MODEL from '@/components/auth/teams_area/resources/inviteModel.json';

import { LOGIN } from '@/vuex/types/actions';
import MainAccountCard from '@/components/auth/teams_area/MainAccountCard';
import NotificationsButton from '@/components/profile/sections/profile/notifications/NotificationsButton';


export default {
  components: {
    MainAccountCard,
    NotificationsButton,
    FilterTable,
    CancellationModal,
  },
  data() {
    return {
      tabIndex: 0,
      itemsMyTeams: [],
      itemsInvite: [],
      selectedModal: {},
      selectedModalItem: null,
      owner: {},
      fieldsMyTeams: MY_TEAMS_MODEL.fields,
      fieldsInvite: INVITES_MODEL.fields,
      templates: [
        { key: 'actions' },
      ],
    };
  },
  methods: {
    showModal(modelBase, isMyTeamTab, item) {
      this.selectedModal = {
        isMyTeamTab,
        title: modelBase.title,
        deleteButtonLabel: modelBase.deleteButtonLabel,
        description: `${modelBase.description} <b>${helper.decodeHtml(item.borrower_name)}</b>.`,
      };
      this.selectedModalItem = item;
      this.$refs.cancellationModal.show();
    },
    clickOnEnter(item) {
      const data = {
        id: item.id,
      };
      const url = `/users/${this.$store.getters.user.id}/teams_area/enter`;
      this.$reqs.post(url, data)
        .then((response) => {
          this.$store.dispatch(LOGIN, response.data);
          this.$router.push({ name: 'MyDeals' });
        });
    },
    clickOnDisconnect(item) {
      this.showModal(MY_TEAMS_MODEL.modal, true, item);
    },
    clickOnAcceptInvite(item) {
      const data = {
        id: item.id,
      };
      const url = `/users/${this.$store.getters.user.id}/teams_area/accept_invitation`;
      this.$reqs.post(url, data)
        .then(() => {
          this.reloadData();
          this.tabIndex = 0;
        });
    },
    clickOnRejectInvite(item) {
      this.showModal(INVITES_MODEL.modal, false, item);
    },
    submitDisconnect() {
      const data = {
        id: this.selectedModalItem.id,
      };
      const url = `/users/${this.$store.getters.user.id}/teams_area/disconnect`;
      this.$reqs.post(url, data)
        .then(() => {
          this.reloadData();
        });
    },
    submitInviteReject() {
      const data = {
        id: this.selectedModalItem.id,
      };
      const url = `/users/${this.$store.getters.user.id}/teams_area/reject_invitation`;
      this.$reqs.post(url, data)
        .then(() => {
          this.reloadData();
        });
    },
    deleteClicked() {
      this.$refs.cancellationModal.hide();

      if (this.selectedModal.isMyTeamTab) {
        this.submitDisconnect();
      } else {
        this.submitInviteReject();
      }
    },
    reloadData() {
      const url = `/users/${this.$store.getters.user.id}/teams_area/load`;
      this.$reqs.get(url)
        .then((response) => {
          this.itemsMyTeams = response.data.my_teams;
          this.itemsInvite = response.data.invites;
          this.owner = response.data.owner;
        });
    },
  },
  computed: {
    joinedCount() {
      return this.itemsMyTeams.length;
    },
    activeInvitations() {
      return this.itemsInvite.filter(invitation => invitation.status === 'pending').length;
    },
  },
  mounted() {
    this.reloadData();
  },
};
</script>

<style scoped>

#team-area-container {
  padding-top: 40px;
}

.top20 {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/teams_area/TeamsArea.vue